import { Box } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import CopyableText from '../../../components/CopyableText';
import PartyDisplay from '../../../components/PartyDisplay';
import { StateCell, Status } from '../../../components/StateCell';
import { StyledHeader } from '../../../components/Table/Header';
import { InstrumentsById } from '../../../hooks/queries/useGetAllInstrumentConfigurations';
import { fmt, formatTimestamp, parseTimestampToDate } from '../../../utils/common';
import { Row } from './types';

export const createHeaders: (instrumentsById: InstrumentsById) => GridColDef<Row>[] = (
  instrumentsById,
) => {
  return [
    {
      field: 'state',
      headerName: 'State',
      renderHeader: () => (
        <StyledHeader sx={{ ml: 2.5 }} variant="caption">
          State
        </StyledHeader>
      ),
      renderCell: (params) => (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <StateCell state={params.row.state as Status} />
        </Box>
      ),
      flex: 80,
      valueGetter: (params) => params.row.state,
      filterable: true,
      minWidth: 100,
    },
    {
      field: 'sender',
      headerName: 'Sender',
      renderCell: (params) => <PartyDisplay party={params.row.payload.sender} />,
      flex: 100,
      filterable: true,
      valueGetter: (params) => params.row.payload.sender, // todo needed?
      minWidth: 100,
    },
    {
      field: 'receiver',
      headerName: 'Receiver',
      renderCell: (params) => <PartyDisplay party={params.row.payload.receiver} />,
      flex: 100,
      filterable: true,
      valueGetter: (params) => params.row.payload.receiver,
      minWidth: 100,
    },
    {
      field: 'instrumentId',
      headerName: 'Instrument Id',
      valueGetter: (params) => params.row.payload.instrumentId.id,
      renderCell: (params) => <CopyableText value={params.row.payload.instrumentId.id} />,
      filterable: true,
      minWidth: 100,
      flex: 100,
    },
    {
      field: 'tokenName',
      headerName: 'Token Name',
      valueGetter: (params) =>
        instrumentsById[params.row.payload.instrumentId.id]?.payload.tokenName || '',
      filterable: true,
      minWidth: 100,
      flex: 100,
    },
    {
      field: 'tokenSymbol',
      headerName: 'Token Symbol',
      valueGetter: (params) =>
        instrumentsById[params.row.payload.instrumentId.id]?.payload.tokenSymbol || '',
      filterable: true,
      minWidth: 100,
      flex: 100,
    },
    {
      field: 'cusip',
      headerName: 'CUSIP',
      valueGetter: (params) =>
        instrumentsById[params.row.payload.instrumentId.id]?.payload.cusip || '',
      filterable: true,
      minWidth: 100,
      flex: 100,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      renderCell: (params) => fmt(params.row.payload.amount, 2),
      valueGetter: (params) => Number(params.row.payload.amount),
      filterable: false,
      minWidth: 70,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      type: 'dateTime',
      valueGetter: (params) => parseTimestampToDate(params.row.createdAt),
      renderCell: (params) => formatTimestamp(params.row.createdAt),
      flex: 150,
      minWidth: 180,
    },
  ];
};
